import WaveSurfer from 'wavesurfer';
const $ = jQuery;
const AudioPlayer = function(config){
    this.config = config;

    this.data = [];
    this.init();
};
AudioPlayer.prototype = {
    pause: function(){
        this.player.pause();
        this.setStatus('paused');
        this.$controls.playPause.find('.icon-play-pause', this).removeClass('icon-pause').addClass('icon-play');   


    },
    play: function(){
        this.player.play();
        this.setStatus('playing');
        this.$controls.playPause.find('.icon-play-pause', this).removeClass('icon-play').addClass('icon-pause');   

    },

    init: function(){
        this.$player = $(this.config.sel);
        this.playerId = this.$player.data('playerId');
        if (!this.$player.length) {
            alert('invalid player selector');
            return;
        }
        this.config.wavesurfer.container = this.config.sel + "-wavesurfer";
        this.config.waveUrl = $(this.config.sel).data('waveUrl');
        this.subtitlesState = true;
        var IAP = this;

        this.$controls = {
            playPause: $(IAP.config.sel+ ' [role="play-pause"]'),
            download: $(IAP.config.sel+' [role="download"]'),
            toggleSubtitles: $(IAP.config.sel+' [role="toggle-subtitles"]'),
            toggleMute: $(IAP.config.sel+' [role="toggle-mute"]'),
            nextChapter: $(IAP.config.sel+' [role="next-chapter"]'),
            prevChapter: $(IAP.config.sel+' [role="prev-chapter"]'),
            background: $('.'+this.playerId+'-background'),
            chapters: $('[data-link-to="'+this.playerId+'"][role="chapters"]')
            
        }



        this.$time = $(IAP.config.sel+' [role="current-time"]');
        this.$totalTime = $(IAP.config.sel+' [role="total-time"]');
        if (!this.config.srtUrl){
            this.$controls.toggleSubtitles.hide(0);
        }
        if (this.$controls.chapters.find('[data-time]').length==0){
            this.$controls.nextChapter.hide(0);
            this.$controls.prevChapter.hide(0);
        }

        this.$subtitles = $('[data-link-to="audio-player-'+this.playerId+'"][role="subtitles"]');
        if (this.config.srtUrl){
            this.loadSubtitles();
        }
        this.$bg = $(this.config.sel +' [role="poster"]');
        this.player = WaveSurfer.create(this.config.wavesurfer);
        if (this.config.waveUrl){
            $.get(this.config.waveUrl, function(wave){
                IAP.player.load(IAP.config.file, wave.data, 'auto');
            });
        }
        else{
            this.player.load(this.config.file);
        }
        this.player.on('ready', function(){
            var time = IAP.player.getDuration();
            var minutes = Math.floor((time % 3600) / 60);
            var seconds = ('00' + Math.floor(time % 60)).slice(-2);
            IAP.$totalTime.text( minutes + ':' + seconds);
            IAP.load();
            IAP.$controls.playPause.click(function(){
                if (!IAP.player.isPlaying()){
                    IAP.play();
                }
                else {
                    IAP.pause();
                }

            });
            IAP.player.on('finish', function(){
                IAP.setStatus('ended');
                IAP.$controls.playPause.find('.icon-play-pause').removeClass('icon-pause').addClass('icon-play');
            });

        });

        this.currentSubtitle = null;
        this.currentChapter = null;

        this.currentBackground = null;

        this.player.on('audioprocess', function (time) {
            IAP.updateTime(time);
            if (IAP.data.length < 1) return;
            IAP.updateSubtitles(time);
            IAP.updateChapters(time);
        });


        this.$controls.toggleMute.click(function(){
            var state = !IAP.player.isMuted;
            IAP.player.setMute(state);
            if (!state){
                $('[class^="icon"]', this).removeClass('icon-volume-off').addClass('icon-volume-on');
            }
            else {
                $('[class^="icon"]', this).removeClass('icon-volume-on').addClass('icon-volume-off');

            }
        });
        this.$controls.toggleSubtitles.click(function(){
            var state = !IAP.subtitlesState;
            IAP.setSubtitlesState(state);
            if (state){
                $('[class^="icon"]', this).removeClass('icon-subs-off').addClass('icon-subs-on');
            }
            else {
                $('[class^="icon"]', this).removeClass('icon-subs-on').addClass('icon-subs-off');

            }
        });
        this.$controls.chapters.on('click', '[data-time]', function(){
            var chapterStartTime = parseFloat($(this).data('time'));
            var chapterBg = $(this).data('background');
            if (chapterBg){

            }
            var progress = chapterStartTime/IAP.player.getDuration();
            IAP.player.seekTo(progress);
            IAP.play();
        });
        this.$controls.nextChapter.click(function(){
            var next, current = IAP.$controls.chapters.find('.active');
            if (current.length) {
                next = current.parent().next();
            }
            if (!next || !next.length){
                next = IAP.$controls.chapters.find('li:first-child');
            }
            var chapterStartTime = parseFloat(next.find('[data-time]').data('time'));
            var progress = chapterStartTime/IAP.player.getDuration();
            IAP.player.seekTo(progress);
        });
        this.$controls.prevChapter.click(function(){
            var prev, current = IAP.$controls.chapters.find('.active');
            if (current.length) {
                prev = current;
            }
            if (!prev || !prev.length){
                prev = IAP.$controls.chapters.find('li:first-child');
            }
            prev.trigger('click');
        });
        this.players = this.players || {};


    },

    setStatus(status){
        $(this.config.sel).removeClass('pjs-playing').removeClass('pjs-paused').removeClass('pjs-ended');
        $(this.config.sel).addClass('pjs-'+status);
    },

    setSubtitlesState: function(state){
        this.subtitlesState = state;
        if (state){
            this.getSubtitles().show();
        }
        else {
            this.getSubtitles().hide();
        }
        return this;
    },


    load: function(){

        if (this.data.length < 1){
            return;
        }
        var IAP = this;
        var lastChapterID = 0;

        this.data.forEach(function(el){
            if (el.type !="subtitle"){

                el.startTime = IAP.helpers.parseTime(el.start);
                el.endTime = IAP.helpers.parseTime(el.end);
                if (el.startTime >= el.endTime){
                    alert('Error element has incorrect start and end time');
                }
            }
            if (el.type=='chapter'){
                el.chapterID = lastChapterID;
                lastChapterID++; 
                var chapterProgress = el.startTime/IAP.player.getDuration();
                IAP.$controls.chapters.append('<li chapter="'+el.chapterID+'" chapterProgress="'+chapterProgress+'">'+el.data+'</li>');
                IAP.$controls.nextChapter.show();
                IAP.$controls.prevChapter.show();

            }
        });
    },
    loadSubtitles: function() {
        var IAP = this;
        var strip = function (s) {
            return s.replace(/^\s+|\s+$/g,'');
        };
        $.get(this.config.srtUrl, function (srt) {
            srt = srt.replace(/\r\n|\r|\n/g, '\n');
            srt = strip(srt);
            var srt_ = srt.split('\n\n');
            var subtitles = [];
            for(var s=0; s<srt_.length; s++) {
                var st = srt_[s].split('\n');
                if(st[0] === ''){
                    st.shift();
                }
                if(st.length >=2) {
                    var n = st[0],
                    i = strip(st[1].split(' --> ')[0]),
                    o = strip(st[1].split(' --> ')[1]),
                    t = st[2];
                    if(st.length > 2) {
                        for(var j=3; j<st.length;j++){
                            if($(window).width() < 480) {
                                t += ' ';
                            } else {
                                t += '<br/>';
                            }
                            t += st[j];
                        }
                    }
                    subtitles.push({
                        start:i, 
                        startTime:IAP.helpers.parseTime(i),
                        end:o, 
                        endTime:IAP.helpers.parseTime(o),
                        type:"subtitle",
                        data: t
                    });
                }
            }
            IAP.data = IAP.data.concat( subtitles);
            if (subtitles.length){    
                $(IAP.config.sel).trigger('subtitles-ready');
            }
        });

    },
    updateTime:  function(time){
        var minutes = Math.floor((time % 3600) / 60);
        var seconds = ('00' + Math.floor(time % 60)).slice(-2);
        this.$time.text( minutes + ':' + seconds);

    },
    updateBackground: function(time){
        var bg = this.getCurrentBackground(time);
        if (bg != this.currentBackground ){
            this.currentBackground = bg;
        }

        else {
            return "";
        }        
        if (bg){
            var $bg = this.$bg;
            this.$bg.fadeOut(function(){
                $bg.css('backgroundImage', 'url('+bg.data+')');
            }).fadeIn();
        }
        else {
            this.$bg.fadeOut().css('backgroundImage', '').fadeIn();
        }
    },
    updateSubtitles: function(time){ 
        var subtitle = this.getCurrentSubtitle(time);
        if (subtitle != this.currentSubtitle ){
            this.currentSubtitle = subtitle;
        }

        else {
            return "";
        }        
        if (subtitle){
            this.getSubtitles().html(subtitle.data)

        }
        else {
            this.getSubtitles().html('')
        }
    },
    getSubtitles(){
        return $('body  [data-link-to="'+this.config.id+'"][role="subtitles"]');
    },
    updateChapters: function(time){
        var chapter = this.getCurrentChapter(time);
        if (!chapter) return null;
        if (this.currentChapter && chapter && this.currentChapter[0]==chapter[0]){
            return;
        }
        this.currentChapter = chapter;
        this.$controls.chapters.find('[data-time]').removeClass('active');
        chapter.addClass('active');
        if (chapter){
            this.$controls.chapters.find('li[chapter="'+chapter.chapterID+'"]').addClass('active');
            let bg = chapter.data('background');
            if (bg && this){
                this.$controls.background.find('.image').fadeOut(200, ()=>{
                    this.$controls.background.find('.image').css('backgroundImage', 'url('+bg+')').show();                    
                });

            }
        }


    },
    getCurrentSubtitle: function(time){
        var current = null;
        this.data.forEach(function(el){
            if (el.startTime <= time && el.endTime > time && el.type=="subtitle"){
                current = el;
            }
        });
        return current;
    },
    getCurrentBackground: function(time){
        var current = null;
        this.data.forEach(function(el){
            if (el.startTime <= time && el.endTime > time && el.type=="background"){
                current = el;
            }
        });
        return current;

    },
    getCurrentChapter: function(time){
        var current = null;
        this.$controls.chapters.find('[data-time]').each(function(){
            if ($(this).data('time') <= time ){
                current = $(this);
            }
        });
        return current;
    },
    getStatus: function(){

    },
    helpers: {
        parseTime :function(str){
            var a = str.split(':');
            var seconds = (parseInt(a[0])) * 60 * 60 + parseInt(a[1]) * 60 + parseFloat(a[2]);

            return seconds;
        }
    }
}

export default AudioPlayer;